import { AppCountry } from "@/constants/app.constant"
import { ErrorCode } from "./request.codes"

export const SpecialErrorCodes = {
  get UseBackendMessageCodes() {
    return AppCountry.isVn ? [ErrorCode.GetShopBaseFailed] : []
  }
}
